import { render } from "./CircularProgress.vue?vue&type=template&id=3084e6b6"
import script from "./CircularProgress.vue?vue&type=script&lang=js"
export * from "./CircularProgress.vue?vue&type=script&lang=js"

import exportComponent from "/home/annex/www/kamminga-wagtail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__